/* import __COLOCATED_TEMPLATE__ from './clear-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./clear-button.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());